import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getDashboard, GetDashboardParams, DashboardResponse } from '@/api/dashboard';

export function useDashboard(params?: GetDashboardParams) {
  return useQuery<DashboardResponse, AxiosError<{ message?: string }>>({
    queryKey: ['dashboard', params],
    queryFn: () => getDashboard(params),
    placeholderData: (previousData) => previousData,
  });
}
